<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11IKA32/tc-custom/9780300240665.jpg?1708774727810" alt="This image is the cover for the book Broken Bargain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Broken Bargain
      </h1>
      <p class="bookDescription body article font2">
        <b>“A sweeping account of financial calamities . . . shows how often we’ve been wracked by crises, and how quickly we forget why, setting up the next one.” —Mark Zandi, Chief Economist, Moody’s Analytics</b><br/><br/>In the 1930s, battered and humbled by the Great Depression, the U.S. financial sector struck a grand bargain with the federal government. Bankers gained a safety net in exchange for certain curbs on their freedom: transparency rules, record-keeping and antifraud measures, and fiduciary responsibilities. Despite subsequent periodic changes in these regulations, the underlying bargain played a major role in preserving the stability of the financial markets as well as the larger economy. By the free-market era of the 1980s and 90s, however, Wall Street argued that rules embodied in New Deal–era regulations to protect consumers, and ultimately taxpayers, were no longer needed—and government agreed.<br/><br/>This clear, deeply researched history documents the country’s financial crises, focusing on those of the 1920s, the 1980s, and the 2000s, revealing how the two more recent crises arose from the neglect of this fundamental bargain, and how taxpayers have been left with the bill.<br/><br/> “An engaging analysis . . . The section on the S &amp; L crisis is excellent.” —<i>Choice</i> <br/><br/>“A fluent if dispiriting study of an economic system that forgives those at the top so long as those at the bottom remain willing to foot the bill.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathleen Day
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?484a5134